import { render } from "./FaqBody.vue?vue&type=template&id=d9ba5350&scoped=true"
import script from "./FaqBody.vue?vue&type=script&lang=js"
export * from "./FaqBody.vue?vue&type=script&lang=js"

import "./FaqBody.vue?vue&type=style&index=0&id=d9ba5350&scoped=true&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ba5350"]])

export default __exports__